import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { TaxesFilters, TaxSlice } from "./taxesTypes.ts";

const initialState: TaxSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "id",
    order: "asc",
  },
};

export const taxesSlice = createSlice({
  name: "taxes",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<TaxSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action: PayloadAction<TaxSlice["rowsPerPage"]>) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof TaxesFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<TaxSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  taxesSlice.actions;

export const selectPage = (state: RootState) => state.taxes.page;
export const selectRowsPerPage = (state: RootState) => state.taxes.rowsPerPage;
export const selectFilter = (state: RootState) => state.taxes.filter;
export const selectSort = (state: RootState) => state.taxes.sort;

export default taxesSlice.reducer;
